import React from 'react'
import Productlist from '../components/productlist/Productlist'


const Products = () => {

  
  return (
    <>
    <Productlist/>
    </>
  )
}

export default Products
